export default __webpack_public_path__ + "static/media/guaduales.ac9734df.jpeg";